<template>
    <div class="network-password-change">
        <div class="open-wrapper pointer" @click="openModal">
            <slot>
                <a href="javascript://void(0)">Open</a>
            </slot>
        </div>

        <modal :name=modalId
               :adaptive="true"
               :scrollable="true"
               height="auto">
            <div class="dashboard-block">
                <form @submit.prevent="submit" method="POST" accept-charset="UTF-8"
                      novalidate="novalidate">
                    <header>
                        <h5>Request Network Password Change</h5>
                    </header>

                    <p>Please give the request one full business day to be processed.</p>

                    <div class="important">
                        Changing the password on your private connection will require you to reconnect your devices.
                    </div>

                    <br>

                    <div class="row">
                        <div class="form-group has-feedback col-sm-6"
                             :class="{'has-error': errors.has('password')}">
                            <label for="password">New Password</label>

                            <input autocomplete="password"
                                   id="password"
                                   v-validate="'required|min:4|max:60'"
                                   v-model="password"
                                   name="password"
                                   type="password"
                                   ref="password"
                                   placeholder="Password"
                                   class="form-control"
                                   aria-required="true">

                            <span v-show="errors.has('password')" class="help-block">
                                {{ errors.first('password') }}
                            </span>
                        </div>

                        <div class="form-group has-feedback col-sm-6"
                             :class="{'has-error': errors.has('password-confirm')}">
                            <label for="password-confirm">Confirm Password</label>

                            <input autocomplete="new-password"
                                   id="password-confirm"
                                   v-validate="'required|confirmed:password'"
                                   v-model="passwordConfirm"
                                   name="password-confirm"
                                   type="password"
                                   placeholder="Confirm Password"
                                   class="form-control"
                                   aria-required="true">

                            <span v-show="errors.has('password-confirm')" class="help-block">
                                {{ errors.first('password-confirm') }}
                            </span>
                        </div>
                    </div>

                    <hr>

                    <div class="row">
                        <div class="col-xs-4">
                            <button class="btn btn-link" type="button" @click="closeModal">Back</button>
                        </div>
                        <div class="col-xs-8 text-right">
                            <button class="btn btn-success" type="submit" :disabled="loading">I Understand, Continue
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </modal>
    </div>
</template>

<script>
    export default {
        props: {
            modalId: {
                default(){
                    return Math.random().toString();
                },
                type: String
            },
        },

        data(){
            return {
                loading: false,
                password: null,
                passwordConfirm: null,
            };
        },

        computed: {
            form(){
                var form = document.createElement( 'form' );
                form.setAttribute( 'method', 'POST' );
                form.setAttribute( 'action', '/networkAccess/password' );

                var hiddenField = document.createElement( 'input' );
                hiddenField.setAttribute( 'type', 'hidden' );
                hiddenField.setAttribute( 'name', '_method' );
                hiddenField.setAttribute( 'value', 'POST' );
                form.appendChild( hiddenField );

                var token = $( 'meta[name="csrf-token"]' ).attr( 'content' );
                var tokenField = document.createElement( 'input' );
                tokenField.setAttribute( 'type', 'hidden' );
                tokenField.setAttribute( 'name', '_token' );
                tokenField.setAttribute( 'value', token );
                form.appendChild( tokenField );

                var password = document.createElement( 'input' );
                hiddenField.setAttribute( 'type', 'hidden' );
                hiddenField.setAttribute( 'name', 'NetworkCredential[password]' );
                hiddenField.setAttribute( 'value', this.password );
                form.appendChild( password );

                return form;
            },
        },

        methods: {
            submit(){
                return this.$validator.validateAll()
                    .then( ( valid ) => {
                        if( valid ){
                            this.loading = true;

                            document.body.appendChild( this.form );
                            this.form.submit();
                        }
                    } );
            },

            closeModal(){
                this.$modal.hide( this.modalId );
            },

            openModal(){
                this.$modal.show( this.modalId );
            },
        }
    }
</script>